import * as React from 'react';
import { bexApiDateTimeToTimeLocKeyMap } from 'components/multi-item/bex-api-date-time-to-time-loc-key';
export const StaticTimeSelectOptions = React.memo(({
  l10n
}) => React.createElement(React.Fragment, null, bexApiDateTimeToTimeLocKeyMap.map(([, key]) => React.createElement("option", {
  value: key,
  key: key
}, l10n.formatText(`multiItem.searchWizard.timeSelect.${key}`)))));